import { NgModule } from '@angular/core';
import { WorkflowComponent } from './workflow/workflow.component';
import {CommonModule} from "@angular/common";
import {CompatibilityModule} from "@angular/material/core";

@NgModule({
    declarations: [WorkflowComponent],
  imports: [
    CommonModule,
    CompatibilityModule
  ]
})

/**
 * Main module for the Finance modules.
 */
export class WorkflowModule {}



// WEBPACK FOOTER //
// ./src/app/workflow/workflow.module.ts